module.exports = __webpack_public_path__ + "static/media/zentity.32b6631b.png";